<template>
  <div v-if="isShow" class="list-box">
    <div class="componentclose" @click="close">X</div>
    <div v-if="isShow" id="company-ochart" :style="`zIndex:${zIndex};height:100%`">
      <div :class="{ 'company-ochart-left': true, 'show-menu': showSearch, 'hide-menu': !showSearch }">
        <div class="control-btn" @click="showSearch = !showSearch">操作选项</div>

        <div class="structure-left flex-column">
          <el-tabs v-model="activeTabName">
            <el-tab-pane label="搜索" name="搜索">
              <ul class="search-container">
                <li style="display:flex">
                  <span class="label">姓名：</span>
                  <el-input v-model.trim="search.姓名" class="search" size="mini"></el-input>
                </li>
                <li>
                  <span class="label">职能模块：</span>
                  <el-select v-model="search.职能模块" class="search" filterable multiple size="mini">
                    <el-option v-for="item in categories" :key="item.名称" :value="item.名称"></el-option>
                  </el-select>
                </li>
                <li>
                  <span class="label">部门：</span>
                  <el-select v-model="search.部门" class="search" filterable size="mini">
                    <el-option v-for="item in departments" :key="item._id" :value="item.部门"></el-option>
                  </el-select>
                </li>
              </ul>
              <div class="text-right">
                <span
                  class="radish-btn radish-btn-primary radish-btn-small"
                  style="margin-left: 10px;"
                  @click="toSearch"
                  >搜索</span
                >
                <span
                  class="radish-btn radish-btn-primary radish-btn-small"
                  style="margin-left: 10px;"
                  @click="clearSearch"
                  >清空</span
                >
              </div>
            </el-tab-pane>
            <el-tab-pane label="公司动态" name="公司动态">
              <div class="text-center">
                <span class="radish-btn radish-btn-primary radish-btn-small" style="margin-left: 10px;" @click="refresh"
                  >刷新数据</span
                >
                <span
                  class="radish-btn radish-btn-primary radish-btn-small"
                  style="margin-left: 10px;"
                  @click="showBulletin"
                  >查看公司情报</span
                >
              </div>
            </el-tab-pane>
            <el-tab-pane label="操作" name="操作">
              <div class="text-center">
                <el-popover placement="right" width="700" trigger="click">
                  <div class="radish-btn radish-btn-primary radish-btn-small" @click="uploadParsedXslx">
                    补充已解析表格
                  </div>
                  <FileTable
                    :files="parsedXslx"
                    :paginate="false"
                    width="600"
                    :show-download="isAdmin"
                    height="300"
                    :on-delete="deleteFormerYearListFile"
                  />
                  <div
                    slot="reference"
                    class="radish-btn radish-btn-primary radish-btn-small uploadParsedXslx"
                    style="margin-left: 4px;"
                  >
                    已上传表格
                  </div>
                </el-popover>
                <div
                  v-if="isAdmin"
                  class="radish-btn radish-btn-primary radish-btn-small"
                  style="margin-left: 4px;"
                  @click="deleteTheTable"
                >
                  删除表格
                </div>
                <div
                  v-if="isAdmin || isShuju"
                  class="radish-btn radish-btn-primary radish-btn-small"
                  style="margin-left: 4px;"
                  @click="uploadExcel"
                >
                  上传Excel补全数据
                </div>
                <div
                  class="radish-btn radish-btn-primary radish-btn-small"
                  style="margin-left: 4px;"
                  @click="displayingOchart = !displayingOchart"
                >
                  {{ displayingOchart ? '隐藏ochart' : '显示ochart' }}
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
          <Collapse class="flex-column section flex-left-space" style="overflow: hidden;" :fold="false">
            <template slot="header">
              <h3>
                公司树状图
                <el-tooltip class="item" effect="dark" content="双击部门名称打开相应部门的人选列表" placement="top">
                  <span class="icon">?</span>
                </el-tooltip>
              </h3>
            </template>
            <FormerYearTreeOchart
              ref="FormerYearTreeOchart"
              class="flex-left-space flex-column overflow-auto"
              :departments="departments"
              :department-name="departmentName"
              :company-node="companyNode"
              @showDepartmentList="showDepartmentList"
            ></FormerYearTreeOchart>
          </Collapse>
        </div>
      </div>
      <div :class="{ 'company-ochart-right': true, 'show-menu': showSearch }">
        <div class="above" :style="`height:${displayingOchart ? '30%' : '0%'}`">
          <FormerYearOchart
            ref="FormerYearOchart"
            :company-name="companyName"
            :departments="departments"
            :department-name="departmentName"
            :company-node="companyNode"
            @showDepartmentList="showDepartmentList"
          ></FormerYearOchart>
        </div>
        <div class="below" :style="`height:${displayingOchart ? '70%' : '100%'}`">
          <FormerYearDepartmentList ref="FormerYearDepartmentList"></FormerYearDepartmentList>
        </div>
      </div>
      <!-- 情报 -->
      <Bulletin ref="Bulletin" :company-name="companyName" style="z-index: 30;"></Bulletin>

      <UploadDialog ref="UploadDialog" type="附件" label="list" :on-success="uploadsuccess" :on-error="uploaderror" />
    </div>
  </div>
</template>

<script>
import { FileTable } from '../../../file'
import Collapse from '../baseComponent/Collapse'
import FormerYearOchart from '../formerYearList/FormerYearOchart'
import FormerYearDepartmentList from '../formerYearList/FormerYearDepartmentList.vue'
import Bulletin from '../component/Bulletin'
import FormerYearTreeOchart from '../formerYearList/FormerYearTreeOchart'

export default {
  components: { FileTable, FormerYearOchart, FormerYearDepartmentList, Bulletin, FormerYearTreeOchart, Collapse },
  data() {
    return {
      isLoading: false,
      zIndex: '',
      cid: '',
      year: '',
      companyName: '',
      companyNode: {},
      departments: [],
      departmentName: [],
      isShow: false,
      search: {},
      status: [
        { value: '在职', class: 'el-icon-success icon-blue' },
        { value: '新入职', class: 'el-icon-warning icon-red' },
        { value: '离职', class: 'el-icon-error icon-grey' },
        { value: '未绑定', class: 'el-icon-question icon-lightred' },
      ],
      status2value: { 在职: 2, 新入职: 3, 离职: 4, 未绑定: 1 },
      tree: [],
      showSearch: true,
      nodes: [],
      uploadType: '',
      isAdmin: false,
      parsedXslx: [],
      activeTabName: '搜索',
      displayingOchart: false,
      isShuju: false,
    }
  },
  computed: {
    categories() {
      return app.categories
    },
  },
  watch: {
    $route(to, from) {
      if (Object.keys(to.params).length == 0 && Object.keys(to.query).length == 0) this.close()
    },
    displayingOchart() {
      this.$nextTick(_ => {
        this.$refs.FormerYearDepartmentList && this.$refs.FormerYearDepartmentList.initComponentHeight()
      })
    },
  },
  async mounted() {
    if (!app.categories) {
      await app.getCats()
    }
    if (app.user && app.user.角色 && app.user.角色.includes('管理员')) this.isAdmin = true
    if (app.user && app.user.角色 && app.user.角色.includes('数据处理')) this.isShuju = true
  },
  methods: {
    async open(obj) {
      console.log(obj)
      this.displayingOchart = false
      this.cid = obj.cid
      this.year = obj.year
      this.companyName = obj.companyName
      if (obj.depart) this.search.部门 = obj.depart
      this.isShow = true
      this.tree = []
      this.toSearch()
      this.initData()
    },
    async initData() {
      const match = { cid: this.cid, year: this.year }
      this.isLoading = true
      this.getFormerYearListFile()
      const res = await app.service('company').getFormerYearOchart(match)
      if (res.status === 'success') {
        this.departments = res.data
        this.companyNode = res.companyNode
      } else this.$message.error(res.msg)
      this.isLoading = false
    },
    refresh() {
      this.initData()
      this.toSearch()
    },
    close() {
      this.isShow = false
      this.tree = []
      this.clearSearch()
      this.departments = []
      this.$refs.FormerYearOchart && this.$refs.FormerYearOchart.initChartData()
    },
    async sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms))
    },
    showBulletin() {
      this.$refs.Bulletin.open()
    },
    modifyZIndex() {
      this.zIndex = app.root.dragindex++
    },
    showDepartmentList(nodeData) {
      this.clearSearch()
      if (Array.isArray(nodeData)) {
        const departments = nodeData.map(v => v.部门)
        this.search.部门 = ''
        this.toSearch(departments)
      } else {
        this.search.部门 = nodeData.部门 === this.companyName ? '' : nodeData.部门
        this.toSearch()
      }
    },

    toSearch(departments) {
      if (departments) {
        const { cid, year, companyName, departmentName, search } = this
        this.$nextTick(_ => {
          this.$refs.FormerYearDepartmentList.open({ cid, year, companyName, departmentName, search, departments })
        })
      } else {
        this.departmentName = this.search.部门
        const { cid, year, companyName, departmentName, search } = this
        this.$nextTick(_ => {
          this.$refs.FormerYearDepartmentList.open({ cid, year, companyName, departmentName, search })
        })
      }
    },
    clearSearch() {
      for (const key in this.search) {
        if (Array.isArray(this.search[key])) this.search[key] = []
        else this.search[key] = ''
      }
      this.departmentName = ''
    },
    async uploadParsedXslx() {
      this.uploadType = 'parsedXslx'
      this.$refs.UploadDialog && this.$refs.UploadDialog.visible(true)
      const dom = this.$el.querySelector('.uploadParsedXslx')
      if (dom) dom.click()
    },
    async deleteFormerYearListFile(row) {
      const res = await app.service('company').deleteFormerYearListFile(row)
      if (res.status === 'success') {
        this.parsedXslx = this.parsedXslx.filter(v => v._id !== row._id)
        this.$message('删除成功')
      } else {
        this.$message.error(res.msg)
      }
    },
    async deleteTheTable() {
      this.$confirm('此操作将永久删除该表格, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const res = await app.service('company').deleteFormerYearsList({ cid: this.cid, year: this.year })
          if (res.status === 'success') {
            this.$message('删除成功')
            this.tableData = []
          }
        })
        .catch(() => {
          this.$message({ type: 'info', message: '已取消删除' })
        })
    },
    uploadExcel() {
      this.$refs.UploadDialog && this.$refs.UploadDialog.visible(true)
    },
    async uploadsuccess(responce, file, filelist) {
      if (this.uploadType === 'parsedXslx') {
        this.insertFormerYearListFile(responce[0])
        this.uploadType = ''
      } else {
        const result = await app.service('file').parseXlsx(responce[0])
        const option = Object.assign(
          { table: result.sheetsData, fileId: responce[0].md5 },
          { cid: this.cid, year: this.year },
        )
        const res = await app.service('company').insertFormerYearsList(option)
        this.$message(res.msg)
        this.insertFormerYearListFile(responce[0])
        // const { cid, year } = {cid:this.cid,year:this.year}
        // this.loadData()
      }
    },
    async uploaderror(responce) {
      this.$message.error(responce)
    },
    async insertFormerYearListFile(response) {
      const option = Object.assign({}, response, { cid: this.cid, year: this.year })
      const res = await app.service('company').insertFormerYearListFile(option)
      if (res.status === 'success') {
        this.$message('上传成功')
        this.getFormerYearListFile()
      } else {
        this.$message.error(res.msg)
      }
    },
    async getFormerYearListFile() {
      const res = await app.service('company').getFormerYearListFile({ cid: this.cid, year: this.year })
      if (res.status === 'success') this.parsedXslx = res.data
      else this.$message.error(res.msg)
    },
  },
}
</script>
<style scpoed>
.list-box {
  position: fixed;
  top: 60px;
  left: 0;
  z-index: 30;
  padding-bottom: 10px;
  width: 100vw;
  background-color: #fff;
  height: calc(100% - 60px);
}
.componentclose {
  position: absolute;
  top: 15px;
  right: 20px;
  width: 20px;
  height: 20px;
  line-height: 20px;
  color: #fff;
  text-align: center;
  cursor: pointer;
  background-color: #e83939;
  border-radius: 50%;
  z-index: 1;
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.2), 0 3px 4px rgba(0, 0, 0, 0.14), 0 3px 3px -2px rgba(0, 0, 0, 0.12);
}
</style>
<style src="../../statistics/css/companyOchart.css" scoped></style>
